
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square13 = createMeisterIcons("square-13", [["path",{"fill":"currentColor","d":"M3.75 7A3.26 3.26 0 0 1 7 3.75h10A3.26 3.26 0 0 1 20.25 7v4.25H3.75zm0 5.75V17c0 1.798 1.376 3.25 3.25 3.25h10A3.26 3.26 0 0 0 20.25 17v-4.25zM7 2.25A4.76 4.76 0 0 0 2.25 7v10c0 2.602 2.024 4.75 4.75 4.75h10A4.76 4.76 0 0 0 21.75 17V7A4.76 4.76 0 0 0 17 2.25z","key":"8c4f7a67bb0b0166c02b20228e1a036591a86b7a","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square13
  